function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

import { ono } from "./singleton";
export { Ono } from "./constructor";
export { ono }; // tslint:disable-next-line: no-default-export

export default ono; // CommonJS default export hack

if ((typeof module === "undefined" ? "undefined" : _typeof(module)) === "object" && _typeof(module.exports) === "object") {
  module.exports = Object.assign(module.exports.default, module.exports); // tslint:disable-line: no-unsafe-any
}